import { render, staticRenderFns } from "./PropagationInfo.vue?vue&type=template&id=3803aef1&"
import script from "./PropagationInfo.vue?vue&type=script&lang=js&"
export * from "./PropagationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports